import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Arc-log-Email",
  "use": "icon-Arc-log-Email-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Arc-log-Email\">\n<path d=\"M18.3335 18.3334H3.66683C2.65431 18.3334 1.8335 17.5125 1.8335 16.5V5.42027C1.87622 4.43902 2.68465 3.66576 3.66683 3.66669H18.3335C19.346 3.66669 20.1668 4.4875 20.1668 5.50002V16.5C20.1668 17.5125 19.346 18.3334 18.3335 18.3334ZM4.40016 5.50002L11.0002 9.90002L17.6002 5.50002H4.40016Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/Arc-log-Email.svg
// module id = DP2B
// module chunks = 258